// src/components/LevelTableModal.js
import React, { useState } from 'react';
import { getXpForLevel } from '../utils/levelManager';
import Pagination from './Pagination'; // Переиспользуем наш компонент пагинации

const LEVELS_PER_PAGE = 15;

export default function LevelTableModal() {
  const [page, setPage] = useState(1);
  const totalLevels = 45; // Показываем до 60 уровня
  const totalPages = Math.ceil(totalLevels / LEVELS_PER_PAGE);

  const levelsToShow = Array.from({ length: LEVELS_PER_PAGE }, (_, i) => {
    const level = i + 1 + (page - 1) * LEVELS_PER_PAGE;
    if (level > totalLevels) return null;
    return {
      level: level,
      xp: getXpForLevel(level),
    };
  }).filter(Boolean); // Убираем null, если уровней не кратно 20

  return (
    <div className="level-table-modal">
      <h2>Таблица уровней</h2>
      <div className="levels-grid">
        {levelsToShow.map(({ level, xp }) => (
          <div key={level} className={`level-item ${level === 45 ? 'highlight-mod' : ''} ${level === 30 ? 'highlight-pro' : ''} ${level === 15 ? 'highlight' : ''}`}>
            <span className="level-number">🔼 {level}</span>
            <span className="level-xp">{xp} XP</span>
            {level === 15 && <span className="level-reward">+ дедус</span>}
            {level === 30 && <span className="level-reward">+ турбодед</span>}
            {level === 45 && <span className="level-reward">+ модник?</span>}
          </div>
        ))}
      </div>
      <Pagination 
        currentPage={page} 
        totalPages={totalPages}
        onPageChange={setPage}
      />
    </div>
  );
}